module.exports = __webpack_public_path__ + "img/img32.12162981.png";